'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Menu;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _caligramReact = require('caligram-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Menu(_ref) {
  var showSocialLinks = _ref.showSocialLinks;

  return _react2.default.createElement(
    'nav',
    { className: 'Menu' },
    _react2.default.createElement(
      'ul',
      null,
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'a',
          { href: 'http://pro.caligram.com/coop/' },
          'Coop'
        )
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'a',
          { href: 'http://pro.caligram.com/' },
          'Caligram Pro'
        )
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'a',
          { href: 'http://pro.caligram.com/blogue/' },
          'Blogue'
        )
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'a',
          { href: 'http://pro.caligram.com/contact/' },
          'Contact'
        )
      ),
      showSocialLinks && _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(_caligramReact.Button, { title: 'Facebook', href: 'http://www.facebook.com/caligramcoop', iconLeft: 'facebook', type: 'borderless', hideTitle: true })
      ),
      showSocialLinks && _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(_caligramReact.Button, { title: 'Twitter', href: 'http://www.twitter.com/caligramcoop', iconLeft: 'twitter', type: 'borderless', hideTitle: true })
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu.js
// module id = 1082
// module chunks = 0